module.exports = __webpack_public_path__ + "img/chat-oepn.e7249025.png";